import { useEffect, useState } from "react";
import { Spin, Alert } from "antd";
import planesAccionService from "../../services/informe332/informeServices";
import ReportFilters from "./ReportFilters";
import Analytics from "./Analytics";
import DataTable from "./DataTable";

function normalizeItem(item) {
  const regex = /^\d+-([0-9]{8})_(.+)$/;
  const match = item.archivo.match(regex);

  if (match) {
    const fecha = match[1];
    const rest = match[2];

    return {
      ...item,
      archivo: `${fecha}_${rest}`,
      fecha: fecha,
      dia: fecha.substring(0, 2),
      mes: fecha.substring(2, 4),
      anio: fecha.substring(4, 8),
    };
  }
  return item;
}

export default function Informe332() {
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    proyecto: "",
    mes: "all",
    tipo: "todos",
  });

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await planesAccionService.getReport();
        const cleanedTable = response.table.map(normalizeItem);
        setData({
          ...response,
          table: cleanedTable,
        });

      } catch (err) {
        setError(err?.message || "Error desconocido");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (data?.table) {
      let filtered = [...data.table];
      if (filters.proyecto?.trim()) {
        filtered = filtered.filter((i) =>
          i.proyecto.toLowerCase().includes(filters.proyecto.toLowerCase())
        );
      }
      if (filters.mes && filters.mes !== "all") {
        filtered = filtered.filter((i) => i.mes === filters.mes);
      }
      if (filters.tipo !== "todos") {
        if (filters.tipo === "acompanamiento") {
          filtered = filtered.filter((i) => i.acompanamiento === "X");
        } else if (filters.tipo === "capacitacion") {
          filtered = filtered.filter((i) => i.capacitacion === "X");
        }
      }
      setFilteredData(filtered);
    }
  }, [data, filters]);

  return (
    <div style={{ padding: 30 }}>
      <ReportFilters filters={filters} setFilters={setFilters} data={data} filteredData={filteredData} />
      {loading && (
        <div style={{ textAlign: "center", padding: "3rem 0" }}>
          <Spin spinning tip="Cargando datos...">
            <div style={{ height: 50 }}></div>
          </Spin>
        </div>

      )}
      {error && (
        <Alert
          message="Error al cargar datos"
          description={error}
          type="error"
          showIcon
        />
      )}
      {!loading && !error && (
        <>
          <Analytics data={filteredData} />
          <DataTable data={filteredData} loading={loading} />
        </>
      )}
    </div>
  );
}
